import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withProps } from 'recompose'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { formatTrailerSRLabel } from '../helpers'
import { ButtonWrapper } from '../sharedComponents'

export const GenericTrailerTile = ({ className, active, model, onClick, ...props }) =>
  <ButtonWrapper
    { ...props }
    { ...getOnClickAndOnKeyPressDownEvents(onClick) }
    tabIndex="0"
    data-add-appointment-trailer
    type="button"
    className={ className }
    active={ active }
    aria-label={ !active ? `select I have a ${model}` : `I have a ${model} is selected` }>
    <Media.NonScreenReader>
      <Checked data-at-appointment-trailertile-selected={ active } asset="check-circle" hidden={ !active } />
      <Logo><TrailerIcon asset="icon-trailer" alt={ model } /></Logo>
      <FirstPartOfTitle>I have a</FirstPartOfTitle>
      <GenericTrailerTitle>{ model }</GenericTrailerTitle>
    </Media.NonScreenReader>
  </ButtonWrapper>

const withTrailerAriaLabel = withProps(({ active, model, tireFrontSize, tireRearSize }) => ({
  sRLabel: formatTrailerSRLabel({ active, model, tireFrontSize, tireRearSize })
}))

export const TrailerTile = withTrailerAriaLabel(
  ({ className, active, model, tireFrontSize, tireRearSize, sRLabel, ...props }) =>
    <ButtonWrapper
      type="button"
      className={ className }
      active={ active }
      { ...props }
      aria-selected={ active }
      aria-label={ sRLabel }>
      <Media.NonScreenReader>
        <Checked asset="check-circle" hidden={ !active } />
        <Logo><TrailerIcon asset="icon-trailer" alt={ model } /></Logo>
        <TrailerTitle>
          { model }
        </TrailerTitle>
        <TrailerSize>{ tireRearSize && 'Front: '}{ tireFrontSize }</TrailerSize>
        { tireRearSize && <TrailerSize>Rear: { tireRearSize }</TrailerSize> }
      </Media.NonScreenReader>
    </ButtonWrapper>
)

const propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  model: PropTypes.string,
  onClick: PropTypes.func,
  tireFrontSize: PropTypes.string,
  tireRearSize: PropTypes.string
}

GenericTrailerTile.propTypes = propTypes
TrailerTile.propTypes = { ...propTypes, sRLabel: PropTypes.string }

export default GenericTrailerTile

const Checked = styled(Icon)`
  position: absolute;
  ${Mixin.responsive('right', '15px', '15px')}
  ${Mixin.responsive('top', '8px', '8px')}
`

const Logo = styled.div`
  text-align: center;
  ${Mixin.responsive('height', '7.36em', '4.86em')}
  ${Mixin.middle()}
`

const TrailerIcon = styled(Icon)`
  ${Mixin.responsive('height', '64px', '35px')}
  ${Mixin.responsive('width', '98px', '53px')}
`

const GenericTrailerTitle = styled.div`
  font-weight: 600;
  text-transform: capitalize;
  ${Mixin.responsive('font-size', '18px', '14px')}
  ${Mixin.responsive('min-height', '50px', '40px')}
`
const TrailerTitle = styled.div`
  text-transform: capitalize;
  ${Mixin.responsive('font-size', '14px', '10px')}
`

const TrailerSize = styled.div`
  width: 100%;
  line-height: 21px;
  text-align: left;
  ${Mixin.responsive('font-size', '14px', '10px')}
`

const FirstPartOfTitle = styled.div`
  ${Mixin.responsive('font-size', '14px', '10px')}
`
